const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const validUrl = require('valid-url');

const _ = {
    find:       require('lodash/find'),
    filter:     require('lodash/filter'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');

const RSDActions = require('../../actions/RSDActions');
const RSDStore = require('../../stores/RSDStore');

const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';
import ControlledInput from '../common/ControlledInput';
import LoadingSpinner from '../loading/LoadingSpinner';
import AccessibleIcon from '../common/AccessibleIcon';
import ConfirmModal from '../modal/ConfirmModal';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    saveHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    rsd_service_id: PropTypes.string,
    rsd_id: PropTypes.string,
    title: PropTypes.string,
};

const defaultProps = {
    title: "Skill Descriptor",
};

const BLANK_RSD = {
    name: '',
    description: ''
};

class RSDPickerModal extends React.Component {
    constructor(props) {
        super(props);
        var ss = this.getRSDState(props);
        this.state = {...ss,
            error:null,
            rsd_service_id: props.rsd_service_id,
            rsd_id: props.rsd_id,
        }
        this.unsubscribes = [
            RSDStore.listen(this.onRSDStoreChange),
        ];
    }

    componentDidMount() {
        if (!this.state.rsd_services_initialized) {
            let actionId = uuid.v4();
            this.setState({get_services_actionId: actionId},()=>{
                RSDActions.getChannelRSDServices(actionId,{channelId: this.props.channelId});
            });
        }
        else {
            this.lookup_rsd_id();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    getRSDState=(props,override_rsd_service_id,override_rsd_id)=>{
        let rsdStoreState = RSDStore.getStateChannel(props.channelId);
        let services_initialized = false;
        let rsd_services = [];
        let rsds = [];
        if (rsdStoreState.rsdServices) {
            services_initialized = rsdStoreState.rsdServices.rsd_services ? true : false;
            rsd_services = rsdStoreState.rsdServices.rsd_services || [];
            rsds = rsdStoreState.rsdServices.rsds || [];
        }
        let known_rsds = [];
        let rsd_id = override_rsd_id || props.rsd_id;
        let rsd_service_id = override_rsd_service_id || props.rsd_service_id;
        let serviceData = _.find(rsd_services,{id:rsd_service_id});
        let rsd = BLANK_RSD;
        if (serviceData) {
            if (serviceData.service_type === Globals.RSD_SERVICE_TYPES.MZL) {
                known_rsds = rsds && rsds[rsd_service_id];
            }
            else {
                known_rsds = _.filter(rsdStoreState.external_rsds,{rsd_service_id});
            }
            if (rsd_id) {
                rsd = _.find(known_rsds,{rsd_id});
            }
        }

        return { services_initialized, rsd_services,rsds, known_rsds, rsd };
    }
    
    onRSDStoreChange=(state)=>{
        let rsdState = this.getRSDState(this.props, this.state.rsd_service_id, this.state.rsd_id);
        this.setState(rsdState);
        if (this.state.get_rsd_actionId && (state.action.id === this.state.get_rsd_actionId)) {
            this.setState({get_rsd_actionId: null});
        }
        else if (this.state.get_services_actionId && (state.action.id === this.state.get_services_actionId)) {
            this.setState({get_services_actionId: null},()=>{
                this.lookup_rsd_id();
            });
        }
        else if (this.state.get_rsd_name_actionId && (state.action.id === this.state.get_rsd_name_actionId)) {
            this.setState({get_rsd_name_actionId: null});
            const rsd_id = this.state.rsd_id;
            let rsd = _.find(rsdState.known_rsds,{rsd_id});
            if (!rsd) {
                let error = new ForgeError({message: 'RSD ID not found'});
                this.setState({rsd:BLANK_RSD,error});
            }
        }
    }
    
    lookup_rsd_id=()=>{
        const rsd_id = this.state.rsd_id;
        const rsd_service_id = this.state.rsd_service_id;
        if (!rsd_id || !rsd_service_id) {
            return;
        }
        
        if (!validUrl.isHttpUri(rsd_id) && !validUrl.isHttpsUri(rsd_id)) {
            this.setState({ error: new ForgeError({message: 'RSD url is invalid'}) });
            return;
        }
        
        let serviceData = _.find(this.state.rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            this.setState({ error: new ForgeError({message: 'RSD url is invalid'}) });
            return;
        }
        
        if (serviceData.service_type === Globals.RSD_SERVICE_TYPES.MZL) {
            if (this.state.rsds && this.state.rsds[rsd_service_id]) {
                let rsd = _.find(this.state.rsds[this.state.rsd_service_id],{rsd_id});
                if (rsd) {
                    this.setState({rsd});
                }
                else {
                    let error = new ForgeError({message: 'RSD ID not found'});
                    this.setState({rsd:BLANK_RSD,error});
                }
            }
            else {
                let actionId = uuid.v4();
                this.setState({
                    get_rsd_actionId: actionId,
                    error: null},()=>{
                    RSDActions.getChannelServiceRSDs(actionId,{channelId: this.props.channelId, rsd_service_id});
                });
            }
        }
        else {
            // look up one at a time
            let actionId = uuid.v4();
            this.setState({get_rsd_name_actionId: actionId, error: null},()=>{
                RSDActions.getNameAndDescription(actionId,{channelId: this.props.channelId, rsd_service_id, rsd_id });
            });
        }
    }
    
    get_rsds=()=>{
        const rsd_service_id = this.state.rsd_service_id;
        if (!rsd_service_id) {
            return;
        }
        
        let serviceData = _.find(this.state.rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            return;
        }
        
        if (serviceData.service_type !== Globals.RSD_SERVICE_TYPES.MZL) {
            return;
        }

        let rsdStoreState = RSDStore.getStateChannel(this.props.channelId);
        if (rsdStoreState.rsdServices) {
            if (rsdStoreState.rsdServices.rsd_services) {
                let rsds = rsdStoreState.rsdServices.rsds;
                if (rsds) {
                    let known_rsds = rsds[rsd_service_id];
                    if (known_rsds) {
                        return; // we already have the known rsds
                    }
                }
            }
        }

        let actionId = uuid.v4();
        this.setState({get_rsds_actionId: actionId, error: null},()=>{
            RSDActions.getChannelServiceRSDs(actionId,{channelId: this.props.channelId, rsd_service_id});
        });
    }

    setValue=(key,evt,considerLookup)=>{
        let value = evt.target.value;
        let changes = {
            [key]:value,
            error: null,
        };
        let rsd_service_id = changes.rsd_service_id || this.state.rsd_service_id;
        let rsd_id = changes.rsd_id || this.state.rsd_id;
        let rsdState = this.getRSDState(this.props, rsd_service_id, rsd_id);
        changes = {...changes, ...rsdState };
        this.setState(changes,()=>{
            if (considerLookup) {
                this.lookup_rsd_id();
            }
            if (key === 'rsd_service_id') {
                this.get_rsds();
            }
        });
    }
    
    setService=(evt)=>{
        this.setValue('rsd_service_id',evt,true);
    }
    
    onSave=()=>{
        let {name,description} = this.state.rsd;
        let confirmText = `Update to ${name || "blank name"}\n${description || "blank description"}?`;
        this.setState({
            modalConfirm: {
                modalTitle: "Confirm Update",
                text: confirmText,
                confirmHandler: ()=>{
                    this.setState({modalConfirm: null},()=>{
                        this.props.saveHandler({
                            rsd_service_id: this.state.rsd_service_id, 
                            rsd_id:this.state.rsd_id,
                            rsd: this.state.rsd, // for display purposes
                        });
                    });
                },
                cancelHandler: ()=>{
                    this.setState({modalConfirm: null})
                },
            }
        });
    }

    render() {
        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            return (
                <ConfirmModal key="confirmModal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }
        
        const rsd_service_id = this.state.rsd_service_id;
        const rsd_id = this.state.rsd_id;
        const actionInProgress = (this.state.get_services_actionId || this.state.get_rsd_actionId || this.state.get_rsd_name_actionId);

        let rsd_selector;
        if (this.state.known_rsds && this.state.known_rsds.length) {
            rsd_selector = (
                <select id="subskill-rsd-id-selector" value={''} 
                    readOnly={actionInProgress}
                    onChange={ (evt)=>{ this.setValue('rsd_id',evt,true)} }>
                    <option key="none" value={''}>{''}</option>
                    {this.state.known_rsds.map((rsd,index)=>(
                    <option key={index} value={rsd.rsd_id} title={rsd.name}>{`${rsd.name}`}</option>
                    ))}
                </select>
            );
        }
        
        return (
            <Modal dialogClassName="short-course-subskill-details-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                //container={mountNode}
                onHide={this.props.closeHandler}
                aria-labelledby="subskill-editor"
            >
                <Modal.Header
                    closeButton
                    closeLabel={Strings['en'].common.CLOSE}
                    onHide={this.props.closeHandler}
                >
                    <Modal.Title id="subskill-editor">{this.props.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="formlike subskill-editor-body">
                        <div className="formlike">
                            <label htmlFor="modal-edit-rsd-service-id">{Strings['en'].RSD.RSD_SERVICE_LABEL + ':'}</label>
                            <select id="modal-edit-rsd-service-id" 
                                    value={this.state.rsd_service_id||0} 
                                    onChange={this.setService} readOnly={actionInProgress}>
                                <option key="none" value={0}>None</option>
                                {this.state.rsd_services.map((rsd_service,index)=>(
                                <option key={index} value={rsd_service.id}>{rsd_service.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="formlike">
                            <label htmlFor="subskill-rsd-id">{'RSD ID:'}</label>
                            <div className="input-well">
                                {rsd_selector}
                                <ControlledInput id="subskill-rsd-id" type="text" readOnly={actionInProgress}
                                value={this.state.rsd_id||''} 
                                onChange={this.setValue.bind(this,'rsd_id')}
                                onBlur={this.lookup_rsd_id}
                                />
                            </div>
                        </div>
                        <div className="formlike secondary">
                            <label htmlFor="subskill-name">{'Name:'}</label>
                            <div className="input-well">
                                {this.state.rsd && this.state.rsd.name}
                            </div>
                        </div>
                        <div className="formlike secondary">
                            <label htmlFor="subskill-description">{'Description:'}</label>
                            <div className="input-well">
                                {this.state.rsd && this.state.rsd.description}
                            </div>
                        </div>
                        { actionInProgress ? <LoadingSpinner/> : null }
                    </div>
                    <ErrorBox error={this.state.error} />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={this.onSave}>{Strings['en'].common.UPDATE}</button>
                    <button className="btn btn-primary" onClick={this.props.closeHandler}>{Strings['en'].common.CANCEL}</button>
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // RSDPickerModal

RSDPickerModal.propTypes = propTypes;
RSDPickerModal.defaultProps = defaultProps;

export default RSDPickerModal;